<div class="login-container">
  <h1 class="saniup-name saniup-font mat-display-small">saniup.one</h1>
  <img class="saniup-logo" ngSrc="/logo/Primary.svg" priority width="200" height="100" alt="SaniUp Logo" />

  <div class="login flex flex-column">
    <h2 class="mat-display-small">
      @if (!emailUnbestaetigt()) {
        <span class="shake">👋</span>
      }
      {{ ueberschrift() }}
    </h2>

    @if (hinweis(); as meldung) {
      <lib-info-card [appearance]="meldung.appearance">
        <mat-card>
          <mat-card-content class="info-card-content">
            <mat-icon>{{ meldung.icon }}</mat-icon>
            <div class="hinweis-text">
              <p class="mat-title-medium">{{ meldung.titel }}</p>
              <p class="mat-body-medium">{{ meldung.text }}</p>
              @if (meldung.fussnote) {
                <p class="mat-body-small fussnote">{{ meldung.fussnote }}</p>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </lib-info-card>
    }

    @if (emailUnbestaetigt()) {
      <button type="button" matButton="filled" (click)="login()">Jetzt anmelden</button>
    } @else {
      <!-- Anmelden ist die einzige Aktion, die hier wirklich etwas tut: Zugaenge legt das
           Sanitaetshaus selbst an, „Registrieren" gibt es deshalb nicht mehr. -->
      <button type="button" matButton="filled" (click)="login()">Zum Login</button>
      @if (zugangAnfordernMoeglich) {
        <button type="button" matButton="tonal" (click)="zugangAnfordern()">Noch keinen Zugang?</button>
      }
    }
  </div>

  <div class="legal">
    <p>
      © {{ now | date: 'yyyy' }} SaniUp GmbH -
      <a [routerLink]="[]" (click)="openLegalDialog()">Rechtliche Hinweise</a>
    </p>
  </div>
</div>
